import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import { isEmpty } from "lodash";
import { FC, useEffect, useState } from "react";
import AlertGif from "../../../assets/gif/Exclamation_Mark.json";
import BellIcon from "../../../assets/icons/bell.svg";
import CellphoneIcon from "../../../assets/icons/cellphone .svg";
import ChevronRight from "../../../assets/icons/chevron-right.svg";
import CommonGifAnimation from "../../../components/CustomGifAnimation/CommonGifAnimation";
import CommonMenuListPage from "../../../components/CustomMenuListPage/CommonMenuListPage";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import CustomSwitch from "../../../components/CustomSwitch/CustomSwitch";
import {
  T_AnimationData,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import { Colors } from "../../../styles/constant";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import clevertap, { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import {
  GTAScreenType,
  ModuleNameKey,
  onUserLoginCleverTapStatic,
  pathToModuleName,
  SCREEN_TYPE,
} from "../../../utils/constants";
import TriggerGTAEvent from "../../../utils/GTA";
import {
  getMobileOperatingSystem,
  createUpdatePermissionData,
  getModuleNameFromPath,
} from "../../../utils/helper";
import {
  nativeCallBackMethodForCamera,
  nativeCallBackMethodForLocation,
  nativeCallBackMethodForMicrophone,
  nativeCallBackMethodForNotification,
  nativeCallBackMethodForStorage,
} from "../../../utils/NativeAppEvents";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import {
  useLazyFetchAppPermissionQuery,
  useLazyUpdateAppPermissionQuery,
} from "../GeneralAppElements_Api";
import { setAppPermission } from "../GeneralAppElements_Slice";
import {
  T_Fetch_Permission_Response,
  T_Update_App_Permission_Request,
} from "../GeneralAppElements_Types";
import { useSaveUIException } from "../../../hooks/useSaveUIException";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

declare const window: any;
interface Props {
  handleBackBtnClick: Function;
  pathname?: string;
}
declare global {
  interface Window {
    confirmationCallback: (confirm: boolean) => void;
  }
}

const AppPermissions: FC<Props> = ({ handleBackBtnClick, pathname }) => {
  const [pages, setPages] = useState<string>("app-permission");
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const [fetchAppPermission] = useLazyFetchAppPermissionQuery();
  const [updateAppPermission] = useLazyUpdateAppPermissionQuery();
  const [loader, setLoader] = useState<string>("");
  const appDispatch = useAppDispatch();
  const [state, setState] = useState<{
    permission?: T_Fetch_Permission_Response;
    updatePermissionData?: T_Update_App_Permission_Request;
  }>({
    permission: undefined,
    updatePermissionData: undefined,
  });
  const [openPopUp, setOpenPopUp] = useState<boolean>(false);
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const { triggerSaveUIException } = useSaveUIException();
  const { t } = useAppTranslation("common");
  const os = csAppSlice.NativeDeviceInfo?.deviceName
    ? getMobileOperatingSystem() === "iOS"
      ? "ios"
      : "android"
    : "web";

  useEffect(() => {
    if (os === "android") {
      requestCameraPermissionAndroid();

      const permissionMessageHandler = (event: CustomEvent) => {
        console.log(
          "Permission Message from React Native Android: ",
          event.detail,
        );
        const cameraPermissionInfo = event.detail === "true";
        console.log("Camera Permission ", cameraPermissionInfo);
        callPermissionApi("camera", cameraPermissionInfo);
      };

      window.addEventListener(
        "android_camera_permission",
        permissionMessageHandler,
      );

      requestNotificationPermissionAndroid();

      const permissionsMessageHandler = (event: CustomEvent) => {
        console.log(
          "Permission sms Message from React Native Android: ",
          event.detail,
        );
        const permissionInfo = event.detail === "true";
        console.log("Notification Permission ", permissionInfo);
        callPermissionApi("all-notification", permissionInfo);
      };

      window.addEventListener(
        "android_notification_permission",
        permissionsMessageHandler,
      );

      requestLocationPermissionAndroid();

      const locationMessageHandler = (event: CustomEvent) => {
        console.log(
          "Location Permission Message from React Native Android: ",
          event.detail,
        );
        const locationPermissionInfo = event.detail === "true";
        callPermissionApi("location", locationPermissionInfo);
      };

      window.addEventListener(
        "android_location_permission",
        locationMessageHandler,
      );

      requestStoragePermissionAndroid();

      const storageMessageHandler = (event: CustomEvent) => {
        console.log(
          "Storage Permission Message from React Native Android: ",
          event.detail,
        );
        const storagePermissionInfo = event.detail === "true";
        callPermissionApi("storage", storagePermissionInfo);
      };

      window.addEventListener(
        "android_storage_permission",
        storageMessageHandler,
      );

      requestMicrophonePermissionAndroid();

      const microphoneMessageHandler = (event: CustomEvent) => {
        console.log(
          "Microphone Permission Message from React Native Android: ",
          event.detail,
        );
        const microphonePermissionInfo = event.detail === "true";
        callPermissionApi("microphone", microphonePermissionInfo);
      };

      window.addEventListener(
        "android_microphone_permission",
        microphoneMessageHandler,
      );

      return () => {
        window.removeEventListener(
          "android_camera_permission",
          permissionMessageHandler,
        );
        window.removeEventListener(
          "android_notification_permission",
          permissionsMessageHandler,
        );
        window.removeEventListener(
          "android_location_permission",
          locationMessageHandler,
        );
        window.removeEventListener(
          "android_storage_permission",
          storageMessageHandler,
        );
        window.removeEventListener(
          "android_microphone_permission",
          microphoneMessageHandler,
        );
      };
    }
  }, []);
  useEffect(() => {
    if (os === "ios") {
      // Camera Permission Check
      nativeCallBackMethodForCamera({
        type: "getCameraPermissionInfo",
        isGrant: "false",
      })
        .then((response: any) => {
          console.log("Camera permission response from native code:", response);
          const cameraPermissionInfo = response?.isPermissionEnabled ?? false;
          callPermissionApi("camera", cameraPermissionInfo);
        })
        .catch((error) => {
          console.error("Camera permission error:", error);
        });

      // Location Permission Check
      nativeCallBackMethodForLocation({
        type: "getLocationPermissionInfo",
        isGrant: "false",
      })
        .then((response: any) => {
          console.log(
            "Location permission response from native code:",
            response,
          );
          const locationPermissionInfo = response?.isPermissionEnabled ?? false;
          callPermissionApi("location", locationPermissionInfo);
        })
        .catch((error) => {
          console.error("Location permission error:", error);
        });

      // Storage Permission Check
      nativeCallBackMethodForStorage({
        type: "getStoragePermissionInfo",
        isGrant: "false",
      })
        .then((response: any) => {
          console.log(
            "Storage permission response from native code:",
            response,
          );
          const storagePermissionInfo = response?.isPermissionEnabled ?? false;
          callPermissionApi("storage", storagePermissionInfo);
        })
        .catch((error) => {
          console.error("Storage permission error:", error);
        });

      // Microphone Permission Check
      nativeCallBackMethodForMicrophone({
        type: "getMicrophonePermissionInfo",
        isGrant: "false",
      })
        .then((response: any) => {
          console.log(
            "Microphone permission response from native code:",
            response,
          );
          const microphonePermissionInfo =
            response?.isPermissionEnabled ?? false;
          callPermissionApi("microphone", microphonePermissionInfo);
        })
        .catch((error) => {
          console.error("Microphone permission error:", error);
        });

      // Notification Permission Check
      nativeCallBackMethodForNotification({
        type: "getNotificationPermissionInfo",
        isGrant: "false",
      })
        .then((response: any) => {
          console.log(
            "Notification permission response from native code:",
            response,
          );
          const permissionInfo = response?.isPermissionEnabled ?? false;
          callPermissionApi("notifications", permissionInfo);
        })
        .catch((error) => {
          const currentPath = window?.location?.pathname;
          triggerSaveUIException({
            moduleName: getModuleNameFromPath(currentPath),
            pageName: currentPath || "",
            statusCode: 500,
            uiDisplayMessage: `fileName(AppPermissions.tsx) and functionName(nativeCallBackMethodForCamera) `,
            errorMessage: {
              stk: error.stack || "No stack available",
              msg: error.message || "Unknown error occurred",
            },
          });
        });
    }
  }, []);
  const handleGTMEventCall = (value: string) => {
    TriggerGTAEvent("serv_app_permission_view_all_click", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_app_permissions_list_screen",
      CTA_text: "View_all",
      card_title: value,
    });
  };

  const getAppPermissions = async () => {
    try {
      const response = await fetchAppPermission({
        mobileNo: userDetails?.mobileNumber ?? "",
        csUserId: userDetails?.CS_USER_ID ?? "",
      });

      if (
        response.data?.code === API_STATUS_CODE.SUCCESS &&
        !isEmpty(response.data?.payload)
      ) {
        let res = response.data?.payload;
        let updatePermissionData: T_Update_App_Permission_Request =
          createUpdatePermissionData(res);
        appDispatch(setAppPermission(updatePermissionData));

        setState((prevState) => ({
          ...prevState,
          permission: res,
          updatePermissionData: updatePermissionData,
        }));
      }
    } catch (e) {
      appDispatch(
        setError({
          error: e instanceof Error ? e : new Error(),
          message: "failed",
        }),
      );
    }
  };

  const confirmRevokePermission = () =>
    new Promise<boolean>((resolve) => {
      const handleClose = (confirm: boolean) => {
        setOpenPopUp(false);
        resolve(confirm);
      };
      setOpenPopUp(true);
      window.confirmationCallback = handleClose;
    });

  const updateCameraPermissionAndroid = (isEnabled: boolean) => {
    console.log("camera permission == ", isEnabled);
    const message = {
      action: "UPDATE_CAMERA_PERMISSION",
      isPermissionEnabled: isEnabled,
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const updateNotificationPermissionAndroid = (isEnabled: boolean) => {
    console.log("notification permission == ", isEnabled);
    const message = {
      action: "UPDATE_NOTIFICATION_PERMISSION",
      isPermissionEnabled: isEnabled,
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const requestCameraPermissionAndroid = () => {
    const message = {
      action: "REQUEST_CAMERA_PERMISSION",
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const requestNotificationPermissionAndroid = () => {
    const message = {
      action: "REQUEST_NOTIFICATION_PERMISSION",
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const updateLocationPermissionAndroid = (isEnabled: boolean) => {
    const message = {
      action: "UPDATE_LOCATION_PERMISSION",
      isPermissionEnabled: isEnabled,
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  };

  const updateStoragePermissionAndroid = (isEnabled: boolean) => {
    const message = {
      action: "UPDATE_STORAGE_PERMISSION",
      isPermissionEnabled: isEnabled,
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  };

  const updateMicrophonePermissionAndroid = (isEnabled: boolean) => {
    const message = {
      action: "UPDATE_MICROPHONE_PERMISSION",
      isPermissionEnabled: isEnabled,
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  };

  const requestLocationPermissionAndroid = () => {
    const message = { action: "REQUEST_LOCATION_PERMISSION" };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  };

  const requestStoragePermissionAndroid = () => {
    const message = { action: "REQUEST_STORAGE_PERMISSION" };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  };

  const requestMicrophonePermissionAndroid = () => {
    const message = { action: "REQUEST_MICROPHONE_PERMISSION" };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  };

  const handleUpdate = async (event: any) => {
    try {
      const { name, checked } = event.target;
      setLoader(name);
      if (!checked) {
        const confirmed = await confirmRevokePermission();
        if (!confirmed) {
          setLoader("");
          return;
        }
      }
      callCleverTap(name, checked);
      CallGTAEvent(name, checked);
      if (name === "camera") {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          updateCameraPermissionAndroid(checked);
        } else {
          nativeCallBackMethodForCamera({
            type: "askCameraPermission",
            isGrant: checked,
          })
            .then((response: any) => {
              const cameraPermissionInfo =
                response.isGranted === "granted" ? true : false;
              callPermissionApi("camera", cameraPermissionInfo);
            })
            .catch((error) => {
              const currentPath = window?.location?.pathname;
              triggerSaveUIException({
                moduleName: getModuleNameFromPath(currentPath),
                pageName: currentPath || "",
                statusCode: 500,
                uiDisplayMessage: `fileName(AppPermission.tsx) and functionName - (nativeCallBackMethodForCamera) `,
                errorMessage: {
                  stk: error.stack || "No stack available",
                  msg: error.message || "Unknown error occurred",
                },
              });
            });
        }
        return;
      } else if (name === "phone-settings") {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          updateCameraPermissionAndroid(checked);
          updateLocationPermissionAndroid(checked);
          updateStoragePermissionAndroid(checked);
          updateMicrophonePermissionAndroid(checked);
        } else {
          await nativeCallBackMethodForCamera({
            type: "askCameraPermission",
            isGrant: checked,
          }).catch(() => {});
          await nativeCallBackMethodForLocation({
            type: "askLocationPermission",
            isGrant: checked,
          }).catch(() => {});
          await nativeCallBackMethodForStorage({
            type: "askStoragePermission",
            isGrant: checked,
          }).catch(() => {});
          await nativeCallBackMethodForMicrophone({
            type: "askMicrophonePermission",
            isGrant: checked,
          }).catch(() => {});
          await callPermissionApi("phone-settings", checked);
          setLoader("");
        }
        return;
      } else if (name === "location") {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          updateLocationPermissionAndroid(checked);
        } else {
          nativeCallBackMethodForLocation({
            type: "askLocationPermission",
            isGrant: checked,
          })
            .then((response: any) => {
              const locationPermissionInfo =
                response.isGranted === "granted" ? true : false;
              callPermissionApi("location", locationPermissionInfo);
            })
            .catch((error) => {
              console.error("Location permission error:", error);
            });
        }
        return;
      } else if (name === "storage") {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          updateStoragePermissionAndroid(checked);
        } else {
          nativeCallBackMethodForStorage({
            type: "askStoragePermission",
            isGrant: checked,
          })
            .then((response: any) => {
              const storagePermissionInfo =
                response.isGranted === "granted" ? true : false;
              callPermissionApi("storage", storagePermissionInfo);
            })
            .catch((error) => {
              console.error("Storage permission error:", error);
            });
        }
        return;
      } else if (name === "microphone") {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          updateMicrophonePermissionAndroid(checked);
        } else {
          nativeCallBackMethodForMicrophone({
            type: "askMicrophonePermission",
            isGrant: checked,
          })
            .then((response: any) => {
              const microphonePermissionInfo =
                response.isGranted === "granted" ? true : false;
              callPermissionApi("microphone", microphonePermissionInfo);
            })
            .catch((error) => {
              console.error("Microphone permission error:", error);
            });
        }
        return;
      } else if (name === "notifications" || name === "all-notification") {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          updateNotificationPermissionAndroid(checked);
        } else {
          nativeCallBackMethodForNotification({
            type: "askNotificationPermission",
            isGrant: checked,
          })
            .then((response: any) => {
              console.log("Response from native code:", response);
              const notificationPermissionInfo =
                response.isGranted === "granted" ? true : false;
              callPermissionApi(name, notificationPermissionInfo);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
        return;
      }
      await callPermissionApi(name, checked);
      setLoader("");
    } catch (e) {
      setLoader("");
      appDispatch(
        setError({
          error: e instanceof Error ? e : new Error(),
          message: "failed",
        }),
      );
    }
  };

  const callPermissionApi = async (name: string, checked: any) => {
    let request;
    if (name === "all-notification") {
      let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
      onUserLoginCleverTapData["Identity"] =
        "+91" + userDetails?.mobileNumber || "";
      onUserLoginCleverTapData["Phone"] =
        "+91" + userDetails?.mobileNumber || "";
      onUserLoginCleverTapData["MSG-sms"] = true;
      onUserLoginCleverTapData["MSG-whatsapp"] = true;
      onUserLoginCleverTapData["MSG-push"] = checked;

      clevertap.onUserLogin.push({ Site: onUserLoginCleverTapData });
      triggerCleverTapEvent("onUserLogin", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing App Permissions list Screen",
        isPrevPageNameRequired: true,
        ...onUserLoginCleverTapData,
        MSG_email: onUserLoginCleverTapData["MSG-email"],
        MSG_push: onUserLoginCleverTapData["MSG-push"],
        MSG_sms: onUserLoginCleverTapData["MSG-sms"],
        MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
      });

      request = {
        mobileNumber: userDetails?.mobileNumber ?? "",
        csUserId: userDetails?.CS_USER_ID ?? "",
        permissions: {
          ...state.updatePermissionData?.permissions,
          whatsapp: checked,
          notifications: checked,
          sms: checked,
        },
      };
    } else if (name === "phone-settings") {
      request = {
        mobileNumber: userDetails?.mobileNumber ?? "",
        csUserId: userDetails?.CS_USER_ID ?? "",
        permissions: {
          ...state.updatePermissionData?.permissions,
          camera: checked,
          contact: checked,
          call: checked,
          location: checked,
          storage: checked,
          microphone: checked,
          displayOverOtherApps: checked,
        },
      };
    } else {
      let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
      onUserLoginCleverTapData["Identity"] =
        "+91" + userDetails?.mobileNumber || "";
      onUserLoginCleverTapData["Phone"] =
        "+91" + userDetails?.mobileNumber || "";
      onUserLoginCleverTapData["MSG-sms"] =
        name === "sms" ? checked : onUserLoginCleverTapData["MSG-sms"];
      onUserLoginCleverTapData["MSG-whatsapp"] =
        name === "whatsapp"
          ? checked
          : onUserLoginCleverTapData["MSG-whatsapp"];
      onUserLoginCleverTapData["MSG-push"] =
        name === "notifications"
          ? checked
          : onUserLoginCleverTapData["MSG-push"];
      console.log("onUserLoginCleverTapData", onUserLoginCleverTapData);
      clevertap.onUserLogin.push({ Site: onUserLoginCleverTapData });
      triggerCleverTapEvent("onUserLogin", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing App Permissions list Screen",
        isPrevPageNameRequired: true,
        ...onUserLoginCleverTapData,
        MSG_email: onUserLoginCleverTapData["MSG-email"],
        MSG_push: onUserLoginCleverTapData["MSG-push"],
        MSG_sms: onUserLoginCleverTapData["MSG-sms"],
        MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
      });
      request = {
        mobileNumber: userDetails?.mobileNumber ?? "",
        csUserId: userDetails?.CS_USER_ID ?? "",
        permissions: {
          ...state.updatePermissionData?.permissions,
          [name]: checked,
        },
      };
    }

    const payload = request as T_Update_App_Permission_Request;
    const response = await updateAppPermission(payload);
    if (response.data?.code === API_STATUS_CODE.SUCCESS) {
      let res = response.data?.payload;
      let updatePermissionData: T_Update_App_Permission_Request = {
        csUserId: res.csUserId,
        mobileNumber: res.mobileNumber,
        permissions: {
          tncConsent: res.tncConsent || false,
          privacyConsent: res.privacyConsent || false,
          whatsapp: res.whatsappConsent || false,
          camera: res.cameraPermission || false,
          notifications: res.notificationsPermission || false,
          contact: res.contactsPermission || false,
          call: res.callLogsPermission || false,
          sms: res.messagesPermission || false,
          location: res.locationEnabled || false,
          storage: res.storageEnabled || false,
          microphone: res.microphonePermission || false,
          displayOverOtherApps: res.displayOverOtherAppsEnabled || false,
        },
      };
      setLoader("");
      setState((prevState) => ({
        ...prevState,
        permission: res,
        updatePermissionData: updatePermissionData,
      }));
      appDispatch(setAppPermission(updatePermissionData));
    } else {
      setLoader("");
      appDispatch(
        setError({
          error: response.error as T_ApiResponse<any>,
          message: "failed",
        }),
      );
    }
  };

  const CallGTAEvent = (name: string, checked: any) => {
    let eventName =
      name === "all-notification" || name === "phone-settings"
        ? "serv_app_all_permission_update_click"
        : "serv_wish_to_share_permission_select";
    TriggerGTAEvent(eventName, {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_app_permissions_list_screen",
      card_title: name,
      option_selected: checked ? "enabled" : "disabled",
    });
  };

  const callCleverTap = (name: string, checked: any) => {
    triggerCleverTapEvent("serv_app_all_permission_update_click", {
      ScreenType: SCREEN_TYPE.DashboardScreenType,
      isPrevPageNameRequired: true,
      ScreenName: "Servicing App Permissions list Screen",
      OptionSelected: checked,
      CardTitle: name,
    });
  };

  const checkAnyPermission = (
    permissions: { [key: string]: boolean },
    ...keys: string[]
  ): boolean => {
    return keys.every((key) => permissions[key]);
  };

  const countTruePermissions = (
    permissions: { [key: string]: boolean },
    ...keys: string[]
  ): number => {
    return keys.filter((key) => permissions[key]).length;
  };

  useEffect(() => {
    if (pages === "notification-settings") {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_GAE.gaNotifiSettingsPerList.screenName,
        ScreenType: SCREEN_TYPE.DashboardScreenType,
      });
    } else if (pages === "phone-settings") {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_GAE.gaPhoneSettingPerList.screenName,
        ScreenType: SCREEN_TYPE.DashboardScreenType,
      });
    } else {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_GAE.gaAppPermissionList.screenName,
        ScreenType: SCREEN_TYPE.DashboardScreenType,
      });
    }
  }, [pages]);

  // useEffect(() => {
  //   getAppPermissions();
  //   console.log(state.permission);
  // }, []);
  const renderFunction = () => {
    if (pages === "notification-settings") {
      return (
        <CommonMenuListPage
          title={t("appSettings.titles.notificationSettings")}
          handleBackBtnClick={() => setPages("app-permission")}
          pathname={pathname}
        >
          <Stack spacing={"1rem"} paddingLeft={"1rem"} paddingRight={"1rem"}>
            <Box
              sx={{
                "& > :not(:first-child)": {
                  marginTop: ".25rem",
                  marginBottom: "1rem",
                },
              }}
            >
              <Typography variant="h4" color={Colors.arsenic}>
                {t("appSettings.headings.choosePermissions")}
              </Typography>
              <Typography
                variant="h6"
                fontWeight={400}
                color={"#000000"}
                lineHeight={".975rem"}
              >
                {t("appSettings.headings.adjustPreferences")}
              </Typography>
            </Box>

            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="h5">
                  {t("appSettings.labels.generalNotifications")}
                </Typography>
                <LoadingSwitch
                  loader={loader}
                  disabled={loader !== ""}
                  onChange={(event) => handleUpdate(event)}
                  name="notifications"
                  checked={state.permission?.notificationsPermission}
                />
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                lineHeight={".975rem"}
                color={Colors.arsenic}
                width={"75%"}
              >
                {t("appSettings.descriptions.generalNotifications")}
              </Typography>
            </Box>
            <Divider />
            {/* <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">SMS</Typography>

                  <LoadingSwitch
                    name="sms"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.messagesPermission}
                    loader={loader}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  So as to fetch and pre-fill ABCD App OTPs to provide you
                  hassle free experience
                </Typography>
              </Box>
               <Divider /> 
            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Whatsapp</Typography>
                  <LoadingSwitch
                    loader={loader}
                    name="whatsapp"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.whatsappConsent}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  Get important updates and exclusive offers on WhatsApp.
                </Typography>
              </Box> */}
            {/*   </Stack>
          </CommonMenuListPage>
        );
      case "phone-settings":
        triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
          ScreenName: CT_ScreenEvntDtls.R_GAE.gaPhoneSettingPerList.screenName,
          ScreenType: SCREEN_TYPE.DashboardScreenType,
        });
        return (
          <CommonMenuListPage
            title="Phone settings"
            handleBackBtnClick={() => setPages("app-permission")}
            pathname={pathname}
          >
            <Stack spacing={"1rem"} paddingLeft={"1rem"} paddingRight={"1rem"}>
              <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Typography variant="h4" color={Colors.arsenic}>
                  Choose the permissions you wish to share
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  color={"#000000"}
                  lineHeight={".975rem"}
                >
                  Adjust your app settings to suit your preferences
                </Typography>
              </Box>
              {/* <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Contact</Typography>
                  <LoadingSwitch
                    loader={loader}
                    name="contact"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.contactsPermission}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  To help you access your contact information
                </Typography>
              </Box>
              <Divider /> */}
            {/* <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Camera permission</Typography>

                  <LoadingSwitch
                    loader={loader}
                    name="camera"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.cameraPermission}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  This information will be used to access camera and scan QR
                  code
                </Typography>
              </Box> */}
            {/* <Divider /> */}
            {/* <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Location</Typography>
                  <LoadingSwitch
                    loader={loader}
                    name="location"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.locationEnabled}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  So we can access your location to help you find ABCD utilities
                  around you.
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Storage</Typography>
                  <LoadingSwitch
                    loader={loader}
                    name="storage"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.storageEnabled}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  We use your storage to download documents in the app.
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Call</Typography>
                  <LoadingSwitch
                    loader={loader}
                    name="call"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.callLogsPermission}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  This will be used to adjust how your phone handles calls with
                  Call Settings
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography variant="h5">Display over other apps</Typography>
                  <LoadingSwitch
                    loader={loader}
                    name="displayOverOtherApps"
                    disabled={loader !== ""}
                    onChange={(event) => handleUpdate(event)}
                    checked={state.permission?.displayOverOtherAppsEnabled}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  lineHeight={".975rem"}
                  color={Colors.arsenic}
                  width={"75%"}
                >
                  We need to access SMS to activate UPI and send you bills
                  payment reminders on time
                </Typography>
              </Box> */}
          </Stack>
        </CommonMenuListPage>
      );
    } else if (pages === "phone-settings") {
      return (
        <CommonMenuListPage
          title={t("appSettings.titles.phoneSettings")}
          handleBackBtnClick={() => setPages("app-permission")}
          pathname={pathname}
        >
          <Stack spacing={"1rem"} paddingLeft={"1rem"} paddingRight={"1rem"}>
            <Box
              sx={{
                "& > :not(:first-child)": {
                  marginTop: ".25rem",
                  marginBottom: "1rem",
                },
              }}
            >
              <Typography variant="h4" color={Colors.arsenic}>
                {t("appSettings.headings.choosePermissions")}
              </Typography>
              <Typography
                variant="h6"
                fontWeight={400}
                color={"#000000"}
                lineHeight={".975rem"}
              >
                {t("appSettings.headings.adjustPreferences")}
              </Typography>
            </Box>

            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="h5">
                  {t("appSettings.labels.cameraPermission")}
                </Typography>
                <LoadingSwitch
                  loader={loader}
                  name="camera"
                  disabled={loader !== ""}
                  onChange={(event) => handleUpdate(event)}
                  checked={state.permission?.cameraPermission}
                />
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                lineHeight={".975rem"}
                color={Colors.arsenic}
                width={"75%"}
              >
                {t("appSettings.descriptions.cameraPermission")}
              </Typography>
            </Box>
            <Divider />

            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="h5">
                  {t("appSettings.labels.location")}
                </Typography>
                <LoadingSwitch
                  loader={loader}
                  name="location"
                  disabled={loader !== ""}
                  onChange={(event) => handleUpdate(event)}
                  checked={state.permission?.locationEnabled}
                />
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                lineHeight={".975rem"}
                color={Colors.arsenic}
                width={"75%"}
              >
                {t("appSettings.descriptions.location")}
              </Typography>
            </Box>
            <Divider />

            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="h5">
                  {t("appSettings.labels.storage")}
                </Typography>
                <LoadingSwitch
                  loader={loader}
                  name="storage"
                  disabled={loader !== ""}
                  onChange={(event) => handleUpdate(event)}
                  checked={state.permission?.storageEnabled}
                />
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                lineHeight={".975rem"}
                color={Colors.arsenic}
                width={"75%"}
              >
                {t("appSettings.descriptions.storage")}
              </Typography>
            </Box>
            <Divider />

            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="h5">
                  {t("appSettings.labels.microPhone")}
                </Typography>
                <LoadingSwitch
                  loader={loader}
                  name="microphone"
                  disabled={loader !== ""}
                  onChange={(event) => handleUpdate(event)}
                  checked={state.permission?.microphonePermission}
                />
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                lineHeight={".975rem"}
                color={Colors.arsenic}
                width={"75%"}
              >
                {t("appSettings.descriptions.microPhone")}
              </Typography>
            </Box>
          </Stack>
        </CommonMenuListPage>
      );
    } else {
      return (
        <CommonMenuListPage
          title={t("appSettings.titles.appPermissions")}
          handleBackBtnClick={handleBackBtnClick}
          pathname={pathname}
        >
          <Stack spacing={"1rem"} paddingLeft={"1rem"} paddingRight={"1rem"}>
            <Box
              sx={{
                "& > :not(:first-child)": {
                  marginTop: ".25rem",
                  borderRadius: "1.0625rem",
                  // backgroundColor: "#F9FAFB",
                },
              }}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                marginBottom={".5rem"}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <img src={BellIcon} alt="bell icon" />
                  <Typography
                    variant="h5"
                    color={Colors.arsenic}
                    marginLeft={".2188rem"}
                  >
                    {t("appSettings.titles.notificationSettings")}
                  </Typography>
                </Box>
                <Box display="flex">
                  <Typography
                    variant="h6"
                    lineHeight=".975rem"
                    fontWeight={400}
                    marginRight={".5rem"}
                  >
                    {`${countTruePermissions(
                      state.updatePermissionData?.permissions ?? {},
                      "notifications",
                      // "sms",
                      // "whatsapp"
                    )}/1`}
                  </Typography>
                  <Typography
                    variant="h6"
                    lineHeight=".975rem"
                    sx={{ color: "#0A6A34" }}
                    onClick={() => {
                      triggerCleverTapEvent(
                        "serv_app_permission_view_all_click",
                        {
                          ScreenType: SCREEN_TYPE.DashboardScreenType,
                          isPrevPageNameRequired: true,
                          ScreenName: "Servicing App Permissions list Screen",
                          CardTitle: "Notification settings",
                          ctaText: "view_all",
                        },
                      );

                      setPages("notification-settings");
                      handleGTMEventCall("notification-settings");
                    }}
                  >
                    {t("appSettings.labels.viewAll")}
                  </Typography>
                  <img src={ChevronRight} alt="chevron-right icon" />
                </Box>
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                color={"#000000"}
                lineHeight={".975rem"}
                marginBottom={".5rem"}
              >
                {t("appSettings.descriptions.appPermissions")}
              </Typography>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="subtitle2">
                  {t("appSettings.labels.allowAllPermissions")}
                </Typography>
                <LoadingSwitch
                  disabled={loader !== ""}
                  name="all-notification"
                  loader={loader}
                  checked={checkAnyPermission(
                    state.updatePermissionData?.permissions ?? {},
                    "notifications",
                    // "sms"
                    // "whatsapp"
                  )}
                  onChange={(event) => handleUpdate(event)}
                />
              </Box>
            </Box>
            <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                marginBottom={".5rem"}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <img src={CellphoneIcon} alt="cell-phone icon" />
                  <Typography
                    variant="h5"
                    marginLeft={".2188rem"}
                    color={Colors.arsenic}
                  >
                    {t("appSettings.titles.phoneSettings")}
                  </Typography>
                </Box>
                <Box display="flex">
                  <Typography
                    variant="h6"
                    lineHeight=".975rem"
                    fontWeight={400}
                    marginRight={".5rem"}
                  >
                    {`${countTruePermissions(
                      state.updatePermissionData?.permissions ?? {},
                      "camera",
                      "location",
                      "storage",
                      "microphone",
                    )}/4`}
                  </Typography>
                  <Typography
                    variant="h6"
                    lineHeight=".975rem"
                    sx={{ color: "#0A6A34" }}
                    onClick={() => {
                      triggerCleverTapEvent(
                        "serv_app_permission_view_all_click",
                        {
                          ScreenType: SCREEN_TYPE.DashboardScreenType,
                          isPrevPageNameRequired: true,
                          ScreenName: "Servicing App Permissions list Screen",
                          CardTitle: "Phone settings",
                          ctaText: "view_all",
                        },
                      );
                      setPages("phone-settings");
                      handleGTMEventCall("phone-settings");
                    }}
                  >
                    {t("appSettings.labels.viewAll")}
                  </Typography>
                  <img src={ChevronRight} alt="chevron-right icon" />
                </Box>
              </Box>
              <Typography
                variant="h6"
                fontWeight={400}
                lineHeight={".975rem"}
                color={Colors.arsenic}
                marginBottom={".5rem"}
              >
                {t("appSettings.descriptions.cameraPermission")}
              </Typography>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="subtitle2">
                  {t("appSettings.labels.allowAllPermissions")}
                </Typography>
                <LoadingSwitch
                  disabled={loader !== ""}
                  name="phone-settings"
                  loader={loader}
                  checked={checkAnyPermission(
                    state.updatePermissionData?.permissions ?? {},
                    "camera",
                    // "contact",
                    // "call",
                    // "location",
                    // "storage",
                    // "displayOverOtherApps"
                  )}
                  onChange={(event) => handleUpdate(event)}
                />
              </Box>
            </Box>
          </Stack>
        </CommonMenuListPage>
      );
    }
  };
  return (
    <>
      {renderFunction()}
      <CustomPopup
        open={openPopUp}
        handleOpen={() => {}}
        className={`hl-common-policy-popup-box`}
      >
        <Box className="hl-custom-failure-box">
          <Box style={{ marginTop: "1.625rem" }}>
            <CommonGifAnimation
              width="2.5rem"
              animationData={AlertGif as T_AnimationData}
            />
            <Typography
              variant="h3"
              sx={{ marginTop: "1.5rem", marginBottom: "0.75rem" }}
              textAlign="center"
            >
              {t("appSettings.prompts.revokePermission", {
                permission: loader,
              })}
            </Typography>
          </Box>

          <Typography
            variant="subtitle2"
            color='"#77787B"'
            marginBottom="1.5rem"
            textAlign="center"
          >
            {t("appSettings.descriptions.revokePermission")}
          </Typography>

          <Button
            fullWidth
            variant="contained"
            className="continue-btn"
            onClick={() => {
              TriggerGTAEvent("serv_revoke_permission_cta_click", {
                screen_type: GTAScreenType.DashboardScreenType,
                screen_name: "servicing_homescreen",
                CTA_text: "revoke_permission",
              });
              window.confirmationCallback(true);
            }}
          >
            {t("appSettings.actionButtons.revokePermission")}
          </Button>
        </Box>
      </CustomPopup>
    </>
  );
};

export default AppPermissions;

interface LoadingSwitchProps {
  name: string;
  checked?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  loader: string;
  disabled: boolean;
}

const LoadingSwitch: React.FC<LoadingSwitchProps> = ({
  name,
  checked = false,
  onChange,
  loader,
  disabled,
}) => {
  return (
    <Box position="relative" display="inline-block">
      <CustomSwitch
        onChange={onChange}
        name={name}
        checked={checked}
        inputProps={{ "aria-label": name }}
        disabled={disabled}
      />

      {loader === name && (
        <Box
          position="absolute"
          top={0}
          bottom={0}
          right={checked ? 0 : "auto"} // Align right if checked
          left={!checked ? 0 : "auto"} // Align left if not checked
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress size={24} style={{ color: "#12B28C" }} />
        </Box>
      )}
    </Box>
  );
};
